<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins ds-MultiMenu">
			<!--Report Settings-->
			<div class="ds-Menu ds-MultiMenuItem">
				<h4>Report Settings</h4>

				<div class="ds-MenuGrid">
					<!--Number of Days-->
					<label>Number of Days a report can exist before being purged by the System: </label>
					<!--Dropdown-->
					<select [disabled]="IsLoading() == true" class="form-control" name="NumDays" [(ngModel)]="ReportData.NumDays">
						<option value="" style="display: none"></option>
						<option *ngFor="let o of NumDaysList" [ngValue]="o">
							{{ o }}
						</option>
					</select>
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary" type="button" (click)="UpdateReportSettings()">Update</button>
			</div>

			<!--Infraction Settings-->
			<div class="ds-Menu ds-MultiMenuItem">
				<h4>Infraction Settings</h4>

				<div class="ds-MenuGrid">
					<!--Must add Action-->
					<label for="MustAddAction">Must add an Action from the primary Infraction: </label>
					<input
						[disabled]="IsLoading() == true"
						class="form-control ds-Rect"
						id="MustAddAction"
						type="checkbox"
						[(ngModel)]="InfractionData.MustAddAction"
					/>
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary" type="button" (click)="UpdateInfractionSettings()">Update</button>
			</div>

			<!--StationLogInRequiredDistrict Setting-->
			<div class="ds-Menu ds-MultiMenuItem">
				<h4>ScanStation LogIn Required Setting</h4>

				<div class="ds-MenuGrid">
					<!--Must LogIn Action-->
					<label for="MustLogInAction">ScanStation LogIn Required: </label>
					<input
						[disabled]="IsLoading() == true"
						class="form-control ds-Rect"
						id="MustLogInAction"
						type="checkbox"
						[(ngModel)]="ScanStationMustLogInData.MustLogInAction"
					/>
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary" type="button" (click)="UpdateScanStationMustLogInSetting()">Update</button>
			</div>

			<div *ngIf="user.userID == 0" class="ds-Menu ds-MultiMenuItem">
				<h4>District E-mail Domain (SU Only)</h4>

				<div class="ds-MenuGrid">
					<label>Domain Name: &#64;</label>
					<input [disabled]="IsLoading() == true" class="form-control" type="text" [(ngModel)]="DistrictEmailData.DistrictDomain" />
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary" type="button" (click)="UpdateDistrictEmailSettings()">Update</button>
			</div>

			<div class="ds-Menu ds-MultiMenuItem">
				<h4>Photo ID Settings</h4>

				<div class="ds-MenuGrid">
					<label>Default No Photo Found Image:</label>
					<select [disabled]="IsLoading() == true" class="form-control" name="DefaultNoPhoto" [(ngModel)]="PhotoIDSettingsData.DefaultNoPhoto">
						<option value="" style="display: none"></option>
						<option *ngFor="let o of DefaultNoPhotoList" [ngValue]="o.ImageLibraryID">
							{{ o.ImageLibraryItemName }}
						</option>
					</select>
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary" type="button" (click)="UpdatePhotoIDSettings()">Update</button>
			</div>

			<div *ngIf="user.userID == 0" class="ds-Menu ds-MultiMenuItem">
				<h4>School E-mail Domains (SU Only)</h4>

				<div class="ds-MenuGrid">
					<label for="SchoolDomainAllowed">School Domains Allowed:</label>
					<input
						[disabled]="IsLoading() == true"
						id="SchoolDomainAllowed"
						class="form-control ds-Rect"
						type="checkbox"
						[(ngModel)]="SchoolEmailDomainsData.SchoolDomainAllowed"
					/>
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary" type="button" (click)="UpdateSchoolEmailDomains()">Update</button>
			</div>

			<div class="ds-Menu ds-MultiMenuItem">
				<h4>Default Page</h4>

				<div class="ds-MenuGrid">
					<label for="SchoolDomainAllowed">Page:</label>

					<select [disabled]="IsLoading() == true" class="form-control" name="SelectedDefaultPage" [(ngModel)]="DefaultPageData.SelectedDefaultPage">
						<option value="" style="display: none"></option>
						<option *ngFor="let o of DefaultPageData.lstDefaultPages" [ngValue]="o">
							{{ o.Desc }}
						</option>
					</select>
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary" type="button" (click)="DistrictUpdateDefaultPage()">Update</button>
				<button [disabled]="IsLoading() == true" class="btn btn-danger" type="button" (click)="DistrictResetDefaultPage()">Reset</button>
			</div>

			<div class="ds-Menu ds-MultiMenuItem">
				<h4>Public Transit</h4>

				<div class="ds-MenuGrid">
					<label>Transit Label:</label>
					<input [disabled]="IsLoading() == true" class="form-control" type="text" [(ngModel)]="PublicTransit.TransitLabel" />
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary" type="button" (click)="DistrictUpdatePublicTransit()">Update</button>
			</div>

			<div class="ds-Menu ds-MultiMenuItem">
				<h4>Nightly Attendance</h4>

				<div class="ds-MenuGrid">
					<label for="MarkIsCountPresentAsPresent">Mark valid releases as present:</label>

					<input
						[disabled]="IsLoading() == true"
						id="MarkIsCountPresentAsPresent"
						class="form-control ds-Rect"
						type="checkbox"
						[(ngModel)]="NightlyAttendanceData.MarkIsCountPresentAsPresent"
					/>
				</div>

				<div>
					<p class="ds-InstructionText">
						<span style="font-weight: bold">NOTE:</span> Daily attendance is updated each night and students are marked as absent if they never
						scanned into school. This preference sets how to mark students who have a full-day release with an excuse that counts as present.
						Normally they are just marked as absent but it is recorded that they had a release that day (This makes sense when students must
						physically be in school for x days per year.) Turning this preference on means the students will be marked as present for the day even
						though they didn't enter the building (Doing schoolwork from home would be counted as present).
					</p>
				</div>

				<div class="ds-ULInfo">
					<label class="ds-ULSubHeading">Daily Attendance if turned OFF:</label>
					<ul class="ds-UL">
						<li>Status = Absent</li>
						<li>Entry Type = System Marked Absent</li>
						<li>Excuse = Has Release</li>
					</ul>

					<label class="ds-ULSubHeading">Daily Attendance if turned ON:</label>
					<ul class="ds-UL">
						<li>Status = Present (Even though they never entered the school. Ex. Doing schoolwork from home)</li>
						<li>Entry Type = Assumed Present</li>
						<li>Excuse = Release's Excuse</li>
					</ul>
				</div>

				<button [disabled]="IsLoading() == true" class="btn btn-primary" type="button" (click)="DistrictUpdateNightlyAttendance()">Update</button>
			</div>
		</div>

		<!--Error Message-->
		<div class="TopMargin">
			<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
		</div>
	</div>
</div>
